import React, { FC, useMemo } from 'react';
import styles from './CvTemplate.module.less';
import { CvTemplateData, TEMPLATES } from './CvTemplateModal';
import { TemplateSelectBox } from './TemplateSelectBox';

type Props = {
  selectedTemplateTitle?: string;
  onChangeTemplate?: (value: CvTemplateData) => void;
  profileImage?: string;
};
export const CvTemplateMobileView: FC<Props> = (props) => {
  const getTemplates = useMemo(() => {
    const url = props.profileImage;
    if (url) {
      const name = url.substring(url.lastIndexOf('/') + 1);
      if (name === 'user.png') {
        return TEMPLATES.filter((t) => t.image !== true);
      }
    }
    return TEMPLATES;
  }, [props.profileImage]);
  return (
    <div className={styles.mobileViewContainer}>
      <div className={styles.mobileViewBody}>
        {getTemplates.map((item, index) => (
          <TemplateSelectBox
            onClick={() => {
              props.onChangeTemplate?.(item);
            }}
            selected={item.title === props.selectedTemplateTitle}
            key={index}
            title={item.title}
          />
        ))}
      </div>
    </div>
  );
};
